import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import ACHAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/ACHAppIcon';

import Spacer20 from '../../../Misc/Spacer20.js';
import PayoutsButton from '../OtherComponents/PayoutsButton';

const ACHTransfersStrategy = {
  previewInfo: {
    name: 'ACH Transfers',
    iconSvg: <ACHAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'ACH Transfers',
    category: 'payments',
    details: (
      <div>
        With Housecall Pro Payments, you can be assured that you’re providing the most seamless payment process for your
        customers. No more fumbling with dongles or waiting for checks in the mail. You can easily take payment in the
        field or send invoices to your customers so they can pay for your services online.
        <Spacer20 />
        <h2>Bank Payments (ACH)</h2>
        When you offer ACH payments, your customer will be able to pay directly with their bank account and you will get
        a lower processing fee because it is a bank to bank transfer.
        <Spacer20 />
        Don’t see Bank Payments as an option on your invoices? Check{' '}
        <a href="https://help.housecallpro.com/payments/ach/ach-payments-faq" target="_blank" rel="noreferrer">
          eligibility requirements
        </a>{' '}
        here to see if you qualify.
        <Spacer20 />
        <b>Fee for processing ACH:</b> 1%
        <Spacer20 />
        <b>Processing time for ACH:</b> 1-5 business days
      </div>
    ),
    iconSvg: <ACHAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/448avuu23p?autoPlay=false',
  },
  sellingPoints: {},
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: true,
    title: 'Housecall Pro Add-on Price',
    description: <div>Fee for processing ACH: 1% </div>,
    appActionButton: <PayoutsButton appPathName="ach_transfers" appName="ACH Transfers" />,
  },
  supportContacts: [],
};

export default ACHTransfersStrategy;
